import { Button, Stack, Typography } from '@mui/material';
import { CourseSelection } from './course-selection';
import { BaseDialog } from '@/components/shared/base-dialog';
import type { Course } from '@/models/catalog/course';

interface SearchCourseDialogProps {
  onClose: () => void;
  onSave: (course: Course) => void;
}

export const SearchCourseDialog = ({
  onClose,
  onSave,
}: SearchCourseDialogProps) => {
  return (
    <BaseDialog
      title="Buscar curso recomendado"
      onClose={onClose}
      actionsComponent={
        <>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            variant="contained"
            type="submit"
            form="course-selection-form"
          >
            Salvar
          </Button>
        </>
      }
    >
      <Typography>
        Busque na plataforma Galena o curso que irá te ajudar no desenvolvimento
        da atividade.
      </Typography>
      <Stack gap={2} mt={2}>
        <CourseSelection
          onSubmit={(course) => {
            onSave(course);
            onClose();
          }}
        />
      </Stack>
    </BaseDialog>
  );
};
